<template>
  <div>
    <div class="modal-box" v-show="show">
      <div class="modal-bg" @click="popHide" v-show="show" :flg="flg"></div>
      <div class="modal-container">
        <div class="modal-header">{{ title }}</div>
        <div class="modal-main">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <button class="btn-popup-colse" @click="hideModal">取消</button>
          <button class="btn-popup-qeus" @click="submit">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- 调用
  <app-modal
    :show="orderReceiptFlg" //初始化弹窗显示true  隐藏false
    :title="orderReceiptTitle" //标题
    @hideModal="orderReceiptHide" //取消
    @submit="orderReceiptShow" //确定
    :flg="flg" //判断是true 点击遮罩关闭弹窗
  >
    <p>确认提醒发货吗？</p>
  </app-modal>

-->
<script>
export default {
  name: "appmodal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    flg: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hideModal() {
      this.$emit("hideModal");
    },
    submit() {
      this.$emit("submit");
    },
    popHide() {
      if (this.flg == true) {
        this.$emit("popHide");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.modal-container {
  background: @cfff;
  border-radius: 12px;
  width: 6.4rem;
  text-align: center;
  padding: 0.6rem 0;
  overflow: hidden;
  position: fixed;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
}
.modal-header {
  font-size: @f32;
  font-weight: bold;
}
.modal-main {
  font-size: @f28;
  color: @c666;
  padding: 0.2rem 0.28rem;
}
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 0.28rem 0 0.28rem;
  text-align: center;
}
.modal-footer button {
  min-width: 2.7rem;
  display: inline-block;
  font-size: 0.32rem;
  border-radius: 22px;
  padding: 10px 0;
  margin-right: 0.4rem;
  outline: none;
  border: none;
}
.modal-footer .btn-popup-colse {
  border: solid 1px #ccc;
  color: #666;
}
.modal-footer .btn-popup-qeus {
  border: solid 1px #01b2b6;
  color: #01b2b6;
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/public/modaldig.vue